import Layout from "../components/Layout";
import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import {Toast} from "primereact/toast";

const SuperVisorSkillMatrixDdl = () =>{
    const primeToast = useRef(null)
    const [skillMatrix, setSkillMatrix] = useState([])
    const [tableHeaders, setTableHeaders] = useState([])
    const [editedMatrix, setEditMatrix] = useState([])
    const [activeOpinion, setActiveOpinion] = useState([])

    const {user} = useSelector(state => state["auth"])
    useEffect(() => {
        getMatrixOpinion()

    }, [])

    const getMatrixData = () => {
        axios.get(BASE_URL + "/api/skillmatrix/GetMatrixData")
            .then(response => {
                const matrixList = response.data
                setSkillMatrix(matrixList)
                const headerList = Object.keys(matrixList.length !== 0 ? matrixList[0] : {})
                setTableHeaders(headerList)
            })
            .catch(e => console.log(e))
    }

   /* const onDdlValueChange = e => {
        const obj = {}
        //const empCode = e.currentTarget.getAttribute("data-empcode")
        const registerId = e.currentTarget.getAttribute("data-registerid")
        const jsonKey = e.currentTarget.getAttribute("name")
        const value = e.currentTarget.value;

        if (value === "") {
            e.currentTarget.classList.add("text-error")
            return;
        } else if (parseInt(value) <= 0) {
            e.currentTarget.classList.add("text-error")
            return;
        } else {
            e.currentTarget.classList.remove("text-error")
        }
        const existArr = [...editedMatrix]

        obj["registerId"] = registerId.toString()
        obj["addedBy"] = user.registerID.toString()
        obj["matrixTitle"] = jsonKey
        obj["roleMatrixOpinionID"] = value

        const filteredMatrix = existArr.filter(data => data.matrixTitle === obj.matrixTitle && data.registerId === obj.registerId);
        if (filteredMatrix.length === 0) {
            setEditMatrix([...editedMatrix, obj]);
        } else {
            const existObj = filteredMatrix[0]
            const index = existArr.findIndex(obj => obj.matrixTitle === existObj.matrixTitle && obj.registerId === existObj.registerId);
            console.log(index)
            existObj.roleMatrixOpinionID = value
            existArr[index] = existObj
            setEditMatrix(existArr)

        }
    }*/


    const saveMatrixChanges = () => {
        console.log(JSON.stringify(editedMatrix))
        axios.post(BASE_URL + `/api/skillmatrix/ProcessMatrixData`, JSON.stringify(editedMatrix))
            .then(response => {
               if (response.status === 200){
                   primeToast.current.show({
                       severity: 'success',
                       summary: 'success',
                       detail: 'Matrix Save Successfully',
                       life: 3000
                   });
               }
            }).catch(e => {
            primeToast.current.show({
                severity: 'error',
                summary: 'error',
                detail: 'Matrix Save Not Success please contact with MIS team',
                life: 3000
            });
        })
    }

    const getMatrixOpinion = () =>{
        axios.get(BASE_URL+"/api/matrixopinion/GetAllActiveOpinion")
            .then(response=>{
                if (response.status === 200){
                    setActiveOpinion(response.data)
                    getMatrixData()
                }
            })
            .catch(e=>{
                console.log(e)
            })
    }



    const RenderItem = (value,header)=>{

        if (header === "EmployeeName"){
            return <span>{value["EmployeeName"]}</span>
        }else {
            return  <select
                    onChange={(e)=>{
                    const obj = {}
                    const registerId = e.currentTarget.getAttribute("data-registerid")
                    const jsonKey = e.currentTarget.getAttribute("name")
                    const value = e.currentTarget.value;
                    const existArr = [...editedMatrix]
                    obj["registerId"] = registerId.toString()
                    obj["addedBy"] = user.registerID.toString()
                    obj["matrixTitle"] = jsonKey
                    obj["roleMatrixOpinionID"] = value

                    const filteredMatrix = existArr.filter(data => data.matrixTitle === obj.matrixTitle && data.registerId === obj.registerId);
                    if (filteredMatrix.length === 0) {
                        setEditMatrix([...editedMatrix, obj]);
                    } else {
                        const existObj = filteredMatrix[0]
                        const index = existArr.findIndex(obj => obj.matrixTitle === existObj.matrixTitle && obj.registerId === existObj.registerId);
                        console.log(index)
                        existObj.roleMatrixOpinionID = value
                        existArr[index] = existObj
                        setEditMatrix(existArr)

                    }
                }
                }
                data-registerid={value["RegisterID"]}
                data-empcode={value["EmployeeCode"]}
                defaultValue={value[header]}
                name={header}>
                {activeOpinion.map((opinion,index)=><option key={index} value={opinion.roleMatrixOpinionID}>{opinion.title}</option>)}
            </select>
        }


    }




    return (
        <Layout>
            <Toast ref={primeToast}/>
            <div id="divSkillMatrix" className="p-datatable p-component p-datatable-responsive-stack p-datatable-gridlines">
                <table id="tblSkillMatrix" className="p-datatable-table  table-fixedHeader">
                    <thead className="p-datatable-thead">
                    <tr>{tableHeaders.map((value, index) => value === "RegisterID"? "" : <th role="columnheader" key={index} scope="col">
                        <div className="p-column-header-content"><span className="p-column-title">{value}</span></div>
                    </th>)}</tr>
                    </thead>
                    <tbody>
                    {skillMatrix.map((value, index) => (
                        <tr key={index}>
                            {tableHeaders.map((header, i) => header === "RegisterID" ? "" : <td key={i}>
                                {RenderItem(value,header)}
                                </td>
                            )}
                        </tr>
                    ))}


                    </tbody>
                </table>
            </div>
            <button type="button" onClick={saveMatrixChanges} className="btn btn-primary">Save Changes</button>
        </Layout>
    )
}

export default SuperVisorSkillMatrixDdl